var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMbriCustFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.143 6.15l-5.64 5.644-1.645-1.645c-.44-.44-1.163.25-.707.705l2 2c.194.194.51.194.705 0l5.995-5.998c.2-.196.2-.52 0-.714-.2-.194-.515-.19-.707.008zM1.5 1C.678 1 0 1.678 0 2.5v15c0 .822.678 1.5 1.5 1.5H4v3.5c0 .445.54.668.854.354L8.707 19H22.5c.822 0 1.5-.678 1.5-1.5v-15c0-.822-.678-1.5-1.5-1.5zm0 1h21c.286 0 .5.214.5.5v15c0 .286-.214.5-.5.5h-14c-.133 0-.26.053-.354.147L5 21.293V18.5c0-.276-.224-.5-.5-.5h-3c-.286 0-.5-.214-.5-.5v-15c0-.286.214-.5.5-.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMbriCustFeedback);
export default __webpack_public_path__ + "static/media/mbri-cust-feedback.38f969a7c78f0c98f18ae1a809a9c02d.svg";
export { ForwardRef as ReactComponent };